module.exports = __webpack_public_path__ + "static/media/zhiffy.3300c6a4.webp";